<template>
  <div class="animated-background">
    <div class="floating-elements">
      <span class="element code">{ }</span>
      <span class="element book">📚</span>
      <span class="element graduation">🎓</span>
      <span class="element tech">💻</span>
      <span class="element atom">⚛️</span>
      <span class="element formula">∑</span>
      <span class="element infinity">∞</span>
      <span class="element binary">01</span>
      <span class="element circuit"></span>
      <span class="element grid"></span>
    </div>
  </div>
  
      <v-container fluid class="dashboard">
        <h1 class="mb-6">لوحة التحكم</h1>
        
        <!-- Statistics Cards -->
        <div v-if="!hasRole('Reception')">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-card class="mx-auto stat-card" color="#2F3061">
                <v-card-text class="text-center">
                  <v-icon size="48" color="white" class="mb-2">mdi-door</v-icon>
                  <div class="text-h4  mb-1">{{ stats.roomsCount }}</div>
                  <div class="text-subtitle-1 white--text">القاعات</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="mx-auto stat-card" color="#2F3061">
                <v-card-text class="text-center">
                  <v-icon size="48" color="white" class="mb-2">mdi-school</v-icon>
                  <div class="text-h4 white--text mb-1">{{ stats.coursesCount }}</div>
                  <div class="text-subtitle-1 white--text">الدورات</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="mx-auto stat-card" color="#2F3061">
                <v-card-text class="text-center">
                  <v-icon size="48" color="white" class="mb-2">mdi-coffee</v-icon>
                  <div class="text-h4 white--text mb-1">{{ stats.breaksCount }}</div>
                  <div class="text-subtitle-1 white--text">الاستراحات</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="mx-auto stat-card" color="#2F3061">
                <v-card-text class="text-center">
                  <v-icon size="48" color="white" class="mb-2">mdi-account-group</v-icon>
                  <div class="text-h4 white--text mb-1">{{ stats.usersCount }}</div>
                  <div class="text-subtitle-1 white--text">المستخدمين</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Quick Actions -->
        <div v-if="!hasRole('Reception')">
          <h2 class="my-6">إجراءات سريعة</h2>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-card class="quick-action-card" @click="navigateTo('/users', true)" elevation="5">
                <v-card-text class="text-center pa-6">
                  <v-icon size="36" color="#BF3B74" class="mb-2">mdi-account-plus</v-icon>
                  <div class="text-subtitle-1">إضافة مستخدم</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="quick-action-card" @click="navigateTo('/rooms', true)" elevation="5">
                <v-card-text class="text-center pa-6">
                  <v-icon size="36" color="#BF3B74" class="mb-2">mdi-door-open</v-icon>
                  <div class="text-subtitle-1">إضافة قاعة</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="quick-action-card" @click="navigateTo('/courses', true)" elevation="5">
                <v-card-text class="text-center pa-6">
                  <v-icon size="36" color="#BF3B74" class="mb-2">mdi-book-plus</v-icon>
                  <div class="text-subtitle-1">إضافة دورة</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-card class="quick-action-card" @click="navigateTo('/breaks', true)" elevation="5">
                <v-card-text class="text-center pa-6">
                  <v-icon size="36" color="#BF3B74" class="mb-2">mdi-coffee</v-icon>
                  <div class="text-subtitle-1">إضافة استراحة</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Calendar View -->
        <v-card class="mt-6">
          <v-card-title>التقويم</v-card-title>
          <v-card-text>
            <!-- Calendar Controls -->
            <div class="d-flex align-center mb-4">
              <v-select
                v-model="selectedMonth"
                :items="months"
                label="الشهر"
                class="ml-2"
                density="compact"
                style="width: 150px"
                @update:model-value="updateCalendar"
              ></v-select>
              <v-select
                v-model="selectedYear"
                :items="years"
                label="السنة"
                density="compact"
                style="width: 120px"
                @update:model-value="updateCalendar"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn class="mr-2" icon @click="previousMonth">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn class="mr-2" icon @click="nextMonth">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </div>
            
            <!-- Calendar Grid -->
            <v-sheet class="calendar-grid">
              <!-- Days of Week Header -->
              <div class="calendar-header">
                <div v-for="day in daysOfWeek" :key="day" class="calendar-header-cell">
                  {{ day }}
                </div>
              </div>
              
              <!-- Calendar Days -->
              <div class="calendar-body">
                <div 
                  v-for="(day, index) in calendarDays" 
                  :key="index"
                  class="calendar-day"
                  :class="{ 
                    'current-month': day.currentMonth, 
                    'today': day.isToday,
                    'has-events': getBookingsForDate(day.date).length > 0
                  }"
                >
                  <div class="day-number">{{ day.dayNumber }}</div>
                  <div class="booking-chips">
                    <v-chip
                      v-for="booking in getBookingsForDate(day.date)"
                      :key="booking.id"
                      :color="booking.type === 'room' ? 'primary' : 'success'"
                      size="x-small"
                      class="mt-1"
                      density="compact"
                      :title="`${booking.label} (${booking.time})`"
                    >
                      {{ booking.label.split(' - ')[0] }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-container>
  
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DashboardComponent',
  data() {
    return {
      stats: {
        roomsCount: 0,
        coursesCount: 0,
        breaksCount: 0,
        usersCount: 0
      },
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      calendarDays: [],
      roomBookings: [],
      courseBookings: [],
      showEventDialog: false,
      selectedEvent: null
    }
  },
  computed: {
    ...mapState({
      rooms: state => state.room.rooms,
      courses: state => state.course.courses,
      breaks: state => state.coffee_break.breaks,
      users: state => state.user.users
    }),
    ...mapGetters('auth', ['hasRole']),
    daysOfWeek() {
      return ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
    },
    months() {
      return [
        { title: 'يناير', value: 0 },
        { title: 'فبراير', value: 1 },
        { title: 'مارس', value: 2 },
        { title: 'أبريل', value: 3 },
        { title: 'مايو', value: 4 },
        { title: 'يونيو', value: 5 },
        { title: 'يوليو', value: 6 },
        { title: 'أغسطس', value: 7 },
        { title: 'سبتمبر', value: 8 },
        { title: 'أكتوبر', value: 9 },
        { title: 'نوفمبر', value: 10 },
        { title: 'ديسمبر', value: 11 }
      ];
    },
    years() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 2; i <= currentYear + 5; i++) {
        years.push(i);
      }
      return years;
    }
  },
  methods: {
    logout() {
      this.$router.push('/')
    },
    navigate(route) {
      this.$router.push(route)
    },
    navigateTo(route, shouldShowAddDialog = false) {
      this.$router.push(route);
      if (shouldShowAddDialog) {
        // Set a flag in the route query to show the add dialog
        this.$router.push({ path: route, query: { showAdd: 'true' }});
      }
    },
    async fetchStats() {
      try {
        await Promise.all([
          this.$store.dispatch('fetchRooms'),
          this.$store.dispatch('fetchCourses'),
          this.$store.dispatch('fetchBreaks'),
          this.$store.dispatch('fetchUsers')
        ]);

        this.stats = {
          roomsCount: this.rooms.length,
          coursesCount: this.courses.length,
          breaksCount: this.breaks.length,
          usersCount: this.users.length
        };
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    },
    async fetchBookings() {
      try {
        // Fetch room bookings with details
        const roomResponse = await this.$store.dispatch('fetchRoomBookingsWithDetails');
        if (roomResponse.data.success) {
          // Process room bookings with details
          let processedBookings = [];
          const bookings = roomResponse.data.data || [];
          bookings.forEach(booking => {
            // Process each detail date as a separate calendar entry
            if (booking.details && booking.details.length > 0) {
              booking.details.forEach(detail => {
                processedBookings.push({
                  id: `room-${booking.id}-${detail.id}`,
                  date: detail.date,
                  label: `${this.getRoomName(booking.room_id)} - ${booking.customer}  `,
                  time: `${detail.time_from}-${detail.time_to}`,
                  type: 'room'
                });
              });
            } else {
              // Fallback if no details
              processedBookings.push({
                id: `room-${booking.id}`,
                date: booking.date_from,
                label: `${booking.customer} - ${this.getRoomName(booking.room_id)}`,
                time: `${booking.time_from}-${booking.time_to}`,
                type: 'room'
              });
            }
          });
          this.roomBookings = processedBookings;
        }
        
        // Fetch course bookings
        const courseResponse = await this.$store.dispatch('fetchCourseReservations');
        if (courseResponse.data.success) {
          this.courseBookings = (courseResponse.data.data || []).map(booking => ({
            id: booking.id,
            date: booking.course_schedule?.date_from,
            label: `${booking.course_schedule?.course?.name || 'دورة'} - ${this.getRoomName(booking.course_schedule?.room_id)}`,
            time: booking.course_schedule ? `${booking.course_schedule.time_from}-${booking.course_schedule.time_to}` : '',
            type: 'course'
          }));
        }
      } catch (error) {
        console.error('Error fetching bookings for calendar:', error);
      }
    },
    getBookingsForDate(date) {
      // Format the calendar date as YYYY-MM-DD without timezone conversion
      const calendarDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const dateString = calendarDate.toISOString().split('T')[0];
      
      const bookingsForDate = [
        ...this.roomBookings.filter(booking => {
          // Handle potential date format issues
          if (!booking.date) return false;
          let bookingDate;
          try {
            // Parse the booking date and format it without timezone conversion
            const bookingDateObj = new Date(booking.date);
            bookingDate = new Date(bookingDateObj.getFullYear(), bookingDateObj.getMonth(), bookingDateObj.getDate()).toISOString().split('T')[0];
          } catch (e) {
            console.error('Invalid date format:', booking.date);
            return false;
          }
          return bookingDate === dateString;
        }),
        ...this.courseBookings.filter(booking => {
          if (!booking.date) return false;
          // Handle potential date format issues
          let bookingDate;
          try {
            // Parse the booking date and format it without timezone conversion
            const bookingDateObj = new Date(booking.date);
            bookingDate = new Date(bookingDateObj.getFullYear(), bookingDateObj.getMonth(), bookingDateObj.getDate()).toISOString().split('T')[0];
          } catch (e) {
            console.error('Invalid date format:', booking.date);
            return false;
          }
          return bookingDate === dateString;
        })
      ];
      return bookingsForDate;
    },
    getRoomName(roomId) {
      const room = this.$store.getters.allRooms.find(r => r.id === roomId);
      return room ? room.name : '';
    },
    updateCalendar() {
      this.calendarDays = this.generateCalendarDays(this.selectedYear, this.selectedMonth);
    },
    generateCalendarDays(year, month) {
      const days = [];
      const today = new Date();
      
      // First day of the month
      const firstDay = new Date(year, month, 1);
      // Last day of the month
      const lastDay = new Date(year, month + 1, 0);
      
      // Get the day of the week for the first day (0 = Sunday, 6 = Saturday)
      const firstDayOfWeek = firstDay.getDay();
      
      // Add days from previous month to fill the first row
      const prevMonthLastDay = new Date(year, month, 0).getDate();
      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        const day = prevMonthLastDay - i;
        const date = new Date(year, month - 1, day);
        days.push({
          date,
          dayNumber: day,
          currentMonth: false,
          isToday: this.isSameDay(date, today)
        });
      }
      
      // Add days of the current month
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(year, month, day);
        days.push({
          date,
          dayNumber: day,
          currentMonth: true,
          isToday: this.isSameDay(date, today)
        });
      }
      
      // Add days from next month to complete the grid (6 rows x 7 days = 42 cells)
      const remainingCells = 42 - days.length;
      for (let day = 1; day <= remainingCells; day++) {
        const date = new Date(year, month + 1, day);
        days.push({
          date,
          dayNumber: day,
          currentMonth: false,
          isToday: this.isSameDay(date, today)
        });
      }
      
      return days;
    },
    isSameDay(date1, date2) {
      return date1.getDate() === date2.getDate() &&
             date1.getMonth() === date2.getMonth() &&
             date1.getFullYear() === date2.getFullYear();
    },
    previousMonth() {
      if (this.selectedMonth === 0) {
        this.selectedMonth = 11;
        this.selectedYear--;
      } else {
        this.selectedMonth--;
      }
      this.updateCalendar();
    },
    nextMonth() {
      if (this.selectedMonth === 11) {
        this.selectedMonth = 0;
        this.selectedYear++;
      } else {
        this.selectedMonth++;
      }
      this.updateCalendar();
    },
    showEventDetails(event) {
      this.selectedEvent = event;
      this.showEventDialog = true;
    }
  },
  created() {
    this.fetchStats();
    this.fetchBookings();
    this.updateCalendar();
  }
}
</script>

<!-- Dashboard specific styles only -->
<style scoped>
.dashboard {
  text-align: right;
  direction: rtl;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.booking-chips {
  display: flex;
  flex-direction: column;
  max-height: 80px;
  overflow-y: auto;
  gap: 2px;
}

.booking-chips .v-chip {
  margin: 1px 0;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  cursor: pointer;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(47, 48, 97, 0.2);
  box-shadow: 0 2px 8px rgba(47, 48, 97, 0.08) !important;
  background: rgba(47, 48, 97, 0.1) !important;
  color: #2F3061 !important;
}

/* Calendar navigation buttons */
.v-btn.v-btn--icon {
  background: rgba(47, 48, 97, 0.1);
  color: #2F3061 !important;
}

.v-btn.v-btn--icon:hover {
  background: rgba(47, 48, 97, 0.2);
}
</style>
